import { useEffect, useState } from "react";

// Custom hook for animating numbers
export const useNumberAnimation = (
  initialValue: number,
  targetValue: number,
  duration = 2000,
) => {
  const [currentValue, setCurrentValue] = useState(initialValue);

  useEffect(() => {
    const startTime = Date.now();
    const difference = targetValue - initialValue;

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - (1 - progress) ** 4;
      const newValue = Math.floor(initialValue + difference * easeOutQuart);

      setCurrentValue(newValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [initialValue, targetValue, duration]);

  return currentValue;
};
